import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=c1d7271a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1d7271a')) {
      api.createRecord('c1d7271a', component.options)
    } else {
      api.reload('c1d7271a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=c1d7271a&", function () {
      api.rerender('c1d7271a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cCBq56XRy6oY/JS/comp/ImgFallback.vue"
export default component.exports